export default __webpack_public_path__ + "static/media/onboarding_wave_pattern.e9ba3d13.svg";